import styled, { css } from 'styled-components'

export const ProfileHeader = styled.div`
  background: #E0F8F9;
  color: #555;
  padding: 10px 16px;
  align-items: center;
  justify-content: space-between;
  display: flex;
`
export const ProfileTab = styled.div`
  background: #fff;
  color: #fff;
  display: flex;
  padding-top: 8px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
`
export const ProfileTabItem = styled.div`
  flex: 50%;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #555555;
  text-align: center;
  position: relative;
  border-bottom: 2px solid transparent;
  padding-bottom: 6px;
  cursor: pointer;
  &.active {
    color: #01878E;
    border-color: #01878E;
    svg {
      path {
        fill: #01878E;
      }
    }
  }
`

export const ProfileInfo = styled.div`
  color: #555555;
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-left: 10px;
`
export const ProfileName = styled.div`
  font-family: 'Open Sans';
  font-style: normal;
  font-size: 13px;
  font-weight: 600;
  line-height: 18.85px;
`
export const ProfileCnpj = styled.div`
  font-family: 'Open Sans';
  font-style: normal;
  font-size: 12px;
  font-weight: 400;
  line-height: 17.17px;
`
export const ButtonLogout = styled.button`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.96px;
  color: #01878E;
  background: transparent;
  border: none;
`
export const TabName = styled.div`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-top: 4px;
`

export const NotificationsCount = styled.span`
  width: 15px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  color: #fff;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 12px;
  position: absolute;
  top: -3px;
  right: 50%;
  margin-right: -27px;
  background-color: #FF8200;
  border-radius: 50%;
`
